import React, { useState } from "react"
import { Fragment } from "react/cjs/react.production.min"
import { isAlphabets, isNumberic } from "../utilities"

function UserBankDetailsForm({
    bankFromsData,
    handleBankFormsData,
    accountNumberError,
    handleAccountNumberBlur
}) {

    const [accountNumbError, setAccountNumbError] = useState('')
    const [ifscError, setIfscError] = useState('')

    const handleAccountNumbBlur = () => {
        if (bankFromsData.accountNumber?.length > 0) {
            if (bankFromsData.accountNumber.length < 9 || bankFromsData.accountNumber.length > 18) {
                setAccountNumbError("Please enter a valid account number!")
            } else {
                setAccountNumbError("")
            }
        }
    }
    const handleIfscBlur = () => {
        if (bankFromsData.ifscCode?.length > 0) {
            if (bankFromsData.ifscCode.length < 11) {
                setIfscError("Please enter a valid IFSC code!")
            } else {
                setIfscError("")
            }
        }
    }

    return (
        <Fragment>
            <div className="form-items">
                <label style={{ display: 'flex', alignItems: 'center' }}>Account Name</label>
                <input type="text" placeholder="Enter Bank Account Name" name="bankAccountName"
                    value={bankFromsData.bankAccountName} onChange={handleBankFormsData} onKeyDown={isAlphabets}
                    className="form-controls" />
            </div>
            <div className="form-items">
                <label>Bank Name</label>
                <input type="text" placeholder="Enter Bank Name" name="bankName" value={bankFromsData.bankName}
                    onChange={handleBankFormsData} onKeyDown={isAlphabets} className="form-controls" />
            </div>
            <div className="form-items">
                <label>Account Number</label>
                <input type="text" placeholder="Enter Account Number" name="accountNumber"
                    value={bankFromsData.accountNumber} onChange={handleBankFormsData} onKeyDown={isNumberic}
                    onBlur={handleAccountNumbBlur} className="form-controls" />
                {accountNumbError !== "" &&
                    <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>{accountNumbError}</div>}
            </div>
            <div className="form-items">
                <label>Confirm Account Number</label>
                <input
                    type="text"
                    placeholder="Enter Confirm Account Number"
                    name="confirmAccountNumber"
                    value={bankFromsData.confirmAccountNumber}
                    onChange={handleBankFormsData}
                    onKeyDown={isNumberic}
                    onBlur={handleAccountNumberBlur}
                    className="form-controls"
                />
                {accountNumberError !== "" &&
                    <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>{accountNumberError}</div>}
            </div>
            <div className="form-items">
                <label>IFSC Code</label>
                <input type="text" placeholder="Enter IFSC Code" name="ifscCode" value={bankFromsData.ifscCode}
                    onChange={handleBankFormsData} onBlur={handleIfscBlur} className="form-controls" />
                {ifscError !== "" &&
                    <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>{ifscError}</div>}
            </div>
        </Fragment>
    )
}

export default UserBankDetailsForm
